import { Modules } from "../utils/module-list";
import { getMenu } from "../wp/getMenu";
import { GetStaticPropsContext } from "next";
import {
  CategoryType,
  GlossarReturnedType,
  ImageType,
  MenuType,
} from "../types/baseTypes";
import { globalGetStaticPaths } from "../wp/globalGetStaticPaths";
import { globalGetPageData } from "../wp/globalGetPageData";
import { HeadMeta } from "../components/Header/Head";
import {
  getRelativePathFromLink,
  isValidWpSlug,
  optimizeURL,
} from "../utils/url";
import { hasChildPages } from "../wp/hasChildren";
import {
  getFooterOptions,
  getHeadersOptions,
  getIconsOptions,
  getModuleOptions,
  getShareImage,
} from "../utils/getModuleOptions";
import {
  ModuleOptionsType,
  HeadersOptionsType,
  StartPageType,
  IconsType,
} from "@/types/ModuleOptionsType";
import { filterObjectByArrayKeys } from "../utils/filterObjectByArrayKeys";
import { getThemeOptions } from "../wp/getOptions";
import {
  LabelsType,
  NewsLetterOptionType,
  OptionsBackgroundLayoutType,
  OptionsContactFormType,
  OptionsEndCardsType,
  OptionsFooterType,
  OptionsHeaderType,
  OptionsSearchType,
  OptionsSecurityHeader,
  OptionsSocialMediaType,
  OptionsTopfiGraphicsType,
} from "@/types/OptionType";
import { Footer } from "../components/Footer/Footer";
import {
  BreakpointsOptionsType,
  getBreakpointsFromOptions,
} from "../utils/getData/getBreakpoints";
import { Header } from "../components/Header/Header/Header";
import { Navbar, NavbarOptionType } from "../components/Navbar/Navbar";
import { getInsta } from "../wp/getInsta";
import { getParentPages, ParentsType } from "../wp/getParentPages";
import {
  getTeaserSliderData,
  TeaserSliderDataType,
} from "../utils/getData/getTeaserSliderData";
import {
  getFullWidthSliderData,
  MultipleFullWidthSliderDataType,
} from "../utils/getData/getFullWidthSliderData";
import { SearchResult } from "../components/SearchResult/SearchResult";
import { GlobalContextProvider } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { customPostTypesPathMapping } from "../utils/constants";
import {
  getQuotesSliderData,
  QuotesSliderDataType,
} from "../utils/getData/getQuotesSliderData";
import {
  getLogoSliderData,
  LogoSliderDataType,
} from "../utils/getData/getLogoSliderData";
import MotionPopUp from "../components/PopUp/PopUp";
import {
  getIndexedEventSliderData,
  IndexedEventSliderData,
} from "../modules/EventSlider/getIndexedEventSliderData";
import {
  getIndexedPostSliderData,
  IndexedPostSlidereData,
} from "../modules/PostSlider/getIndexedPostSliderData";
import { useRef } from "react";
import type { Module as ModuleType } from "../wp/types/acf-module-types";
import { getPostForType } from "../wp/getPosts";
import { Button } from "@/components/Global/Button/Button";
import { Section } from "@/components/Global/Section/Section";
import router from "next/router";
import autoLinkGlossarTerms from "@/utils/glossary/glossaryLinking";
import GlossarTooltip from "@/components/GlossarTooltip/GlossarTooltip.tsx";
import { EphemeralStore, EphemeralStoreKey } from "@/utils/ephemeralStore.ts";
import { Modal } from "@/components/Socials/Insta/Modal/Modal";
import { useAppContext } from "@/context/AppContext";
import { Post } from "@/wp/types/client";
import {
  getIndexedRecipeSliderData,
  IndexedRecipeSlidereData,
} from "@/modules/RecipeSlider/getIndexedRecipeSliderData";
import { getGlossarData } from "@/utils/getData/getGlossarData";
import LoginAreaFormWrapper from "@/components/Header/ServiceApiComponents/SharedComponents/LoginAreaFormWrapper/LoginAreaFormWrapper";
import {
  getRecipeFilterOptions,
  SortedCategoriesType,
} from "@/utils/rezeptAPI/getRecipeFilterOptions";
import { getInitialRecipeGridData } from "@/utils/rezeptAPI/getInitialRecipeGridData";
import { RecipeGridResponseType } from "@/modules/RecipeGrid/fetchRecipes";
import { getPopUpData, PopUpType } from "@/utils/getPopUpData";

type Module = ModuleType["module"][number];

interface DynamicPageProps {
  locale: string;
  pageData: Post;
  legalMenu: MenuType;
  mainMenu: MenuType;
  // TODO: Never pass full options object to page props
  // options: OptionsType;
  categories: CategoryType[];
  headerOptions: HeadersOptionsType;
  moduleOptions: ModuleOptionsType;
  socialMedia: OptionsSocialMediaType;
  footerOptions: OptionsFooterType;
  breakpoints: BreakpointsOptionsType | null;
  navbarOption: NavbarOptionType;
  labels: LabelsType;
  footerMenu: MenuType;
  startPageOptions: StartPageType;
  insta: string;
  parents: ParentsType;
  allTeaserData: TeaserSliderDataType[];
  allFullWidthSliderData: MultipleFullWidthSliderDataType[];
  newsletterOptions: NewsLetterOptionType;
  icons: IconsType;
  backgroundImages: OptionsBackgroundLayoutType;
  searchOptions: OptionsSearchType;
  allQuotesData: QuotesSliderDataType[];
  allLogosData: LogoSliderDataType[];
  // popupOptions: popupOptionType;
  // popupData: popupType;
  endCards: OptionsEndCardsType;
  indexedEventSliderData: IndexedEventSliderData;
  indexedPostSliderData: IndexedPostSlidereData;
  indexedRecipeSliderData: IndexedRecipeSlidereData;
  contactOptions: OptionsContactFormType;
  fallbackShareImage: ImageType | false;
  headerThemeOptions: OptionsHeaderType;
  securityHeaderOptions: OptionsSecurityHeader;
  topfiGraphics: OptionsTopfiGraphicsType;
  allGlossarData: GlossarReturnedType;
  initialRecipeData: RecipeGridResponseType | null;
  recipeFilterOptions: SortedCategoriesType;
  popUpData: PopUpType;
}

export default function DynamicPage({
  // TODO: Never pass full options object to page props
  locale,
  pageData,
  headerOptions,
  moduleOptions,
  socialMedia,
  footerOptions,
  breakpoints,
  mainMenu,
  navbarOption,
  labels,
  footerMenu,
  legalMenu,
  startPageOptions,
  insta,
  parents,
  allTeaserData,
  allFullWidthSliderData,
  allQuotesData,
  newsletterOptions,
  icons,
  backgroundImages,
  searchOptions,
  allLogosData,
  endCards,
  indexedEventSliderData,
  indexedPostSliderData,
  indexedRecipeSliderData,
  contactOptions,
  fallbackShareImage,
  headerThemeOptions,
  securityHeaderOptions,
  topfiGraphics,
  allGlossarData,
  initialRecipeData,
  recipeFilterOptions,
  popUpData,
}: DynamicPageProps) {
  const bgColorSearchResults =
    "header_seite" in pageData.acf
      ? pageData?.acf?.header_seite?.breadcrumb_bg_color
      : undefined;
  const popupRef = useRef<HTMLDivElement>(null);
  const mainstartAriaLabel = labels?.find(
    (label) => label.key === "aria_label_mainstart",
  );
  const mainstartLabel = labels?.find((label) => label.key === "skip_nav");

  const isBigParagraph =
    "header_seite" in pageData.acf
      ? pageData.acf?.header_seite?.big_paragraph
      : false;
  const { instagramModal } = useAppContext();

  const handleGoBack = () => {
    const pathSegments = router.asPath.split("/").filter(Boolean); // Filter(Boolean) removes empty strings
    if (pathSegments.length > 0) {
      pathSegments.pop(); // Remove the last segment

      // Construct the new path
      const newPath = "/" + pathSegments.join("/");

      router.replace(newPath || "/"); // Go to '/' if no segments left
    } else {
      router.replace("/");
    }
  };

  return (
    <GlobalContextProvider iconsRaw={icons} labelsRaw={labels}>
      <HeadMeta
        post={pageData}
        fallbackShareImage={fallbackShareImage}
        securityHeaderOptions={securityHeaderOptions}
      />
      <div id="pagestart" tabIndex={-1} />
      {/* eslint-disable-next-line react/forbid-elements */}
      <a
        className="skipnav"
        href="#maincontent"
        {...(mainstartAriaLabel && {
          "aria-label": mainstartAriaLabel.value,
        })}
      >
        {mainstartLabel ? mainstartLabel.value : "Navigation überspringen"}
      </a>
      <Navbar
        searchPageSlug={
          searchOptions?.search_page_link
            ? optimizeURL(searchOptions?.search_page_link) || ""
            : ""
        }
        menu={mainMenu}
        socialMedia={socialMedia.platforms}
        navbarOption={navbarOption}
        pageData={pageData}
        isHome={"header_startseite" in pageData.acf && pageData.slug === "home"}
      />

      {pageData && (
        <>
          <div id="maincontent" />
          <main key={pageData.slug} id={`main-tag`}>
            <LoginAreaFormWrapper filterOptions={recipeFilterOptions}>
              <Header
                locale={locale}
                startPageOptions={startPageOptions}
                post={pageData}
                headerOptions={headerOptions}
                parents={parents}
                options={headerThemeOptions}
                socialMediaThemeOptions={socialMedia}
                backgroundImages={backgroundImages}
                searchPageSlug={
                  searchOptions?.search_page_link
                    ? optimizeURL(searchOptions?.search_page_link) || ""
                    : ""
                }
              />

              {pageData.acf?.module &&
                (pageData.acf.module as Array<Module>).map((module, index) => {
                  const teaserSliderData = allTeaserData.find(
                    (d) => d.index === index,
                  );
                  const fullWidthSliderData = allFullWidthSliderData.find(
                    (d) => d.index === index,
                  )?.data;
                  const quotesSliderData = allQuotesData.find(
                    (d) => d.index === index,
                  );

                  const logoElements = allLogosData.find(
                    (d) => d.index === index,
                  );

                  return (
                    <Modules
                      index={index}
                      key={`${pageData.slug}-${module.acf_fc_layout}-${index}`}
                      module={module}
                      moduleOptions={moduleOptions}
                      breakpoints={breakpoints}
                      insta={insta}
                      socialMedia={socialMedia}
                      endCards={endCards}
                      post={pageData}
                      parents={parents}
                      teaserSliderData={
                        teaserSliderData ? teaserSliderData.data : []
                      }
                      quotesSliderData={
                        quotesSliderData ? quotesSliderData.data : []
                      }
                      fullWidthSliderData={fullWidthSliderData}
                      glossarData={allGlossarData}
                      newsletterOptions={newsletterOptions}
                      logoElements={logoElements ? logoElements.data : []}
                      indexedEventSliderData={indexedEventSliderData}
                      indexedPostSliderData={indexedPostSliderData}
                      indexedRecipeSliderData={indexedRecipeSliderData}
                      isBigParagraph={isBigParagraph}
                      contactOptions={contactOptions}
                      fallbackImages={headerThemeOptions.fallback_images}
                      headerOptions={headerOptions}
                      backgroundImages={backgroundImages}
                      initialRecipeData={initialRecipeData}
                      recipeFilterOptions={recipeFilterOptions}
                      {...(topfiGraphics && { topfiGraphics })}
                    />
                  );
                })}
              {pageData.type !== "page" && (
                <>
                  <Section
                    className="section is-gapless-top"
                    columnsClassName={"is-centered"}
                  >
                    <div className="column is-10-tablet is-8-widescreen is-centered">
                      <Button
                        type={"secondary"}
                        href={""}
                        target={"_self"}
                        title={
                          labels?.find((label) => label.key === "to_overview")
                            ?.value || ""
                        }
                        onClick={() => handleGoBack()}
                        isBack
                      >
                        <span>
                          {labels?.find((label) => label.key === "to_overview")
                            ?.value || ""}
                        </span>
                      </Button>
                    </div>
                  </Section>
                </>
              )}
              <SearchResult
                searchOptions={searchOptions}
                bgColor={bgColorSearchResults || ""}
              />
              <MotionPopUp popupData={popUpData} ref={popupRef} />
              {instagramModal && <Modal />}
            </LoginAreaFormWrapper>
          </main>
        </>
      )}
      <Footer
        autoShowConsentManagement={
          "header_seite" in pageData.acf
            ? pageData.acf?.header_seite?.show_consent_management
            : undefined
        }
        footerOptions={footerOptions}
        socialMedia={socialMedia}
        footerMenu={footerMenu}
        legalMenu={legalMenu}
      />
      <GlossarTooltip key={pageData.slug} />
    </GlobalContextProvider>
  );
}

export async function getStaticPaths({}) {
  const allPaths = await globalGetStaticPaths();
  return {
    paths: allPaths,
    fallback: "blocking",
  };
}

export const isEmptyParentPage = async ({
  pageData,
  locale,
  defaultLocale,
}: {
  pageData: Post;
  locale: string;
  defaultLocale: string;
}): Promise<boolean> => {
  if (!pageData?.acf?.module && pageData.type === "page") {
    const hasChildren = await hasChildPages({
      id: pageData.id,
      locale,
      defaultLocale,
    });
    if (hasChildren) {
      return true;
    }
    return false;
  }
  return false;
};

export async function getStaticProps(context: GetStaticPropsContext) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any --- FIXME: disabled temporarily on migrate to TS.
    const { dynamicRoute }: any = context.params;
    const locale = context.locale || "de";
    const defaultLocale = context.defaultLocale || "de";

    const slug = dynamicRoute?.[dynamicRoute.length - 1];
    if (slug !== undefined && !isValidWpSlug(slug)) {
      return {
        notFound: true,
        revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
      };
    }
    if (context.preview && typeof context.previewData !== "string") {
      return {
        notFound: true,
      };
    }

    const privatePageData = EphemeralStore.getEntry(
      context.previewData as EphemeralStoreKey,
    );
    let pageData =
      context.preview && !privatePageData.isNone
        ? privatePageData.value
        : await globalGetPageData({ dynamicRoute, locale, defaultLocale });

    let constructedPagePath, pagePath;

    if (dynamicRoute) {
      pagePath = getRelativePathFromLink(pageData?.link || "");
      constructedPagePath = `/${
        locale === defaultLocale ? "" : locale + "/"
      }${dynamicRoute.join("/")}/`;
    }

    if (!pageData || pagePath !== constructedPagePath) {
      return {
        notFound: true,
        revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
      };
    }

    // Return 404 for empty parent pages
    if (await isEmptyParentPage({ pageData, locale, defaultLocale })) {
      return {
        notFound: true,
        revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
      };
    }

    const fetchOptions = getThemeOptions({ locale, defaultLocale });

    /*const fetchCategories = getCategories({
      category: "categories",
      locale: context.locale,
      defaultLocale: context.defaultLocale,
    });*/

    const fetchLegalMenu = getMenu({
      slug: context.locale ? "legal-" + context.locale : "legal",
    });
    const fetchFooterMenu = getMenu({
      slug: context.locale ? "footer-" + context.locale : "footer",
    });
    const fetchMainMenu = getMenu({
      slug: context.locale ? "main-" + context.locale : "main",
    });

    // Do not fetch all module options here. Fetch only the ones needed for the page by using _fields parameter
    const fetchModuleAllOptions = getModuleOptions();
    const fetchHeadersAllOptions = getHeadersOptions();
    const fetchFooterAllOptions = getFooterOptions();
    const fetchIconsAllOptions = getIconsOptions();
    const fetchFallbackShareImage = getShareImage();
    const fetchFullWidthSliderData = getFullWidthSliderData({
      pageData,
      locale,
      defaultLocale,
    });
    const fetchGlossarData = getGlossarData(pageData, locale, defaultLocale);

    const fetchTeaserData = getTeaserSliderData(
      pageData,
      locale,
      defaultLocale,
    );
    const fetchQuotesData = getQuotesSliderData(
      pageData,
      locale,
      defaultLocale,
    );
    const fetchLogosData = getLogoSliderData(pageData, locale, defaultLocale);

    const fetchParents = getParentPages({
      nextParent: pageData.parent,
      locale,
      defaultLocale,
    });

    const moduleAllOptions = await fetchModuleAllOptions; //first fetch all module options outside the Promise.all to allow other fetches inside Promise.all to use module options
    const themeOptions = await fetchOptions; // first fetch theme options outside the Promise.all to allow other fetches inside Promise.all to use theme options
    const fetchIndexedEventSliderData = getIndexedEventSliderData({
      pageData,
      eventsSliderOptions: moduleAllOptions?.events_slider,
      locale,
      defaultLocale,
    });
    const fetchIndexedPostSliderData = getIndexedPostSliderData({
      pageData,
      locale,
      defaultLocale,
      fallback_options:
        moduleAllOptions?.slider?.slider_options.fallback_options,
      fallback_image: themeOptions?.header.fallback_images.header_posts,
    });
    const fetchIndexedRecipeSliderData = getIndexedRecipeSliderData({
      pageData,
      locale,
      defaultLocale,
      labels: themeOptions.labels,
      fallback_image: themeOptions?.header.fallback_images.header_posts,
    });

    const fetchInitialRecipe = getInitialRecipeGridData(
      themeOptions.labels,
      pageData.acf.module,
      themeOptions.header.fallback_images.header_posts,
      locale,
    );

    const fetchRecipeFilterOptions = getRecipeFilterOptions();

    const [
      legalMenu,
      mainMenu,
      headersAllOptions,
      footerMenu,
      footerAllOptions,
      iconsAllOptions,
      parents,
      allGlossarData,
      allTeaserData,
      allFullWidthSliderData,
      allQuotesData,
      allLogosData,
      indexedEventSliderData,
      indexedPostSliderData,
      indexedRecipeSliderData,
      fallbackShareImage,
      initialRecipeData,
      recipeFilterOptions,
    ] = await Promise.all([
      fetchLegalMenu,
      fetchMainMenu,
      fetchHeadersAllOptions,
      fetchFooterMenu,
      fetchFooterAllOptions,
      fetchIconsAllOptions,
      fetchParents,
      fetchGlossarData,
      fetchTeaserData,
      fetchFullWidthSliderData,
      fetchQuotesData,
      fetchLogosData,
      fetchIndexedEventSliderData,
      fetchIndexedPostSliderData,
      fetchIndexedRecipeSliderData,
      fetchFallbackShareImage,
      fetchInitialRecipe,
      fetchRecipeFilterOptions,
    ]);

    //check if we have a "parent"/overview page for the post type
    const postTypePath = customPostTypesPathMapping.find(
      (t) => t.postType === pageData?.type && t.language === locale,
    )?.path;
    if (postTypePath) {
      const postTypeOverviewPage = (
        await getPostForType({
          slug: postTypePath,
          type: "pages",
          defaultLocale,
          locale,
          fields: "acf,link,title",
        })
      )?.[0];
      if (postTypeOverviewPage && "header_seite" in postTypeOverviewPage.acf) {
        const headerTitle = postTypeOverviewPage?.acf?.header_seite?.title;
        parents.unshift({
          isEmptyParentPage: false,
          title: headerTitle ?? "",
          url: postTypeOverviewPage?.link,
        });
      }
    }

    // Get a set of all layouts used on the current page
    const uniqueModuleKeys = new Set(
      (pageData.acf?.module as Array<Module>)?.map?.(
        (module) => module?.acf_fc_layout,
      ),
    );

    let breakpoints = null;
    if (
      uniqueModuleKeys.has("textmedia") ||
      uniqueModuleKeys.has("quotes_banner")
    ) {
      breakpoints = await getBreakpointsFromOptions();
    }

    let uniqueModuleKeysArray: string[] = Array.from(uniqueModuleKeys);

    // it uniqueModuleKeysArray has newsletter thre replace it with newsletter_options
    if (uniqueModuleKeysArray.includes("newsletter")) {
      uniqueModuleKeysArray = uniqueModuleKeysArray.map((key) =>
        key === "newsletter" ? "newsletter_options" : key,
      );
    }

    let moduleOptionsForCurrentPage;
    if (moduleAllOptions) {
      // Get all module options for the current page --- DO NOT pass all module options to the page
      moduleOptionsForCurrentPage = filterObjectByArrayKeys(
        moduleAllOptions,
        uniqueModuleKeysArray,
      );
    }

    const glossarHeaderOptions = headersAllOptions?.header_glossar;
    if (glossarHeaderOptions) {
      // If the post type is in the list of post types to link, then link the glossary terms
      // If no post types are specified, then link all glossary terms
      if (glossarHeaderOptions.posttypes_to_link.length > 0) {
        if (glossarHeaderOptions.posttypes_to_link.includes(pageData.type)) {
          pageData = await autoLinkGlossarTerms({
            pageData,
            locale,
            defaultLocale,
            showTooltip: glossarHeaderOptions.show_tooltip,
          });
        }
      } else {
        pageData = await autoLinkGlossarTerms({
          pageData,
          locale,
          defaultLocale,
          showTooltip: glossarHeaderOptions.show_tooltip,
        });
      }
    }

    const popupOptions = moduleAllOptions?.popup;

    const instaFeedId = themeOptions.social_media.instagram_feed_id;
    const insta = await getInsta(instaFeedId || "1");

    const popUpData = await getPopUpData({
      globalPopUp: themeOptions.global_popup,
      individualPopUp: themeOptions.individual_popups,
      context,
      pageID: pageData.id,
    });
    return {
      props: {
        locale,
        pageData,
        legalMenu,
        footerMenu,
        mainMenu,
        headerOptions: headersAllOptions,
        moduleOptions: moduleOptionsForCurrentPage,
        socialMedia: themeOptions.social_media,
        footerOptions: { ...themeOptions.footer, ...footerAllOptions },
        endCards: themeOptions.end_cards,
        breakpoints,
        navbarOption: {
          themeOption: themeOptions.header,
          moduleOption: moduleAllOptions?.navigation,
        },
        labels: themeOptions.labels || [],
        icons: iconsAllOptions,
        backgroundImages: themeOptions.background_layout,
        topfiGraphics: themeOptions.topfi_graphics,
        startPageOptions: !dynamicRoute ? moduleAllOptions?.startpage : null,
        insta,
        parents,
        allTeaserData,
        allFullWidthSliderData,
        allQuotesData,
        // newsletterOptions: themeOptions.newsletter,
        searchOptions: themeOptions.search,
        allLogosData,
        popupOptions,
        // popupData: themeOptions.popup,
        indexedEventSliderData,
        indexedPostSliderData,
        indexedRecipeSliderData,
        contactOptions: themeOptions.contact,
        fallbackShareImage,
        headerThemeOptions: themeOptions.header,
        securityHeaderOptions: themeOptions.security_header,
        allGlossarData,
        initialRecipeData,
        recipeFilterOptions,
        globalPopup: themeOptions.global_popup,
        individualPopups: themeOptions.individual_popups,
        popUpData: popUpData,
      },
      revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
    };
  } catch (error) {
    console.error("Error in getStaticProps: ", error);
    return {
      notFound: true,
      revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
    };
  }
}
